import React, { useEffect, useContext } from 'react';
import { View } from 'dripsy';
import { useAtom } from 'jotai';
import { TrilhasProps } from '../../navigation/types';
import { localAtom } from '../../atoms';
import { LanguageContext } from '../../context/LanguageContext';
import { CIDADE } from '../../values/constants';
import ServiceAlone from '../../components/ServiceAlone';

const Trilhas: React.FC<TrilhasProps> = ({ navigation }) => {
  const [local] = useAtom(localAtom);
  const [{ strings: str }] = useContext(LanguageContext);

  useEffect(() => {
    navigation.setOptions({ headerTitle: `${CIDADE[local]} / ${str.trilhas}` });
  }, [navigation, local, str]);

  return (
    <View sx={{ flex: 1 }}>
      <ServiceAlone repo='Lugares' tipo='trilhas' />
    </View>
  );
};

export default Trilhas;
